import { useApolloClient } from "@vue/apollo-composable";
import { handleError } from "@/services/AlertService";
import GetCompanyDetails from "../queries/GetCompanyDetails.graphql";

// @param {boolean} showErrorMessage - If true, shows error message on error to user. If false, hides error message from user.
export function getCompanyDetails(showErrorMessage = true): Promise<any> {
    const { client } = useApolloClient();
    return new Promise(async (resolve, reject) => {
        try {
            const result = await client.query({
                query: GetCompanyDetails,
            });

            if (result.data.company) {
                resolve(result.data.company);
                return;
            }

            resolve(null);
            return;
        } catch (error) {
            console.error(error);
            if (showErrorMessage) {
                handleError(error);
            }
            reject(error);
        }
    });
}
